<template>
  <div class="content--sinoreg Relatorios">
    <div class="Selos">
      <header-blue>
        Relatório de selos
      </header-blue>
      <form class="mt-3 mb-4"
            action="">
        <div class="d-flex">
          <CustomInput
            class="col-2 mr-3"
            name="numero_do_selo"
            label="Número do selo"
            :initial-value="form.numero_do_selo"
            type="text" 
            @blur="setValueInput" />

          <CustomInput
            class="col-2"
            name="numero"
            label="Número da OS"
            :initial-value="form.numero"
            type="number" 
            @blur="setValueInput" />
          <div class="d-flex align-items-center col-auto">
            <CustomInput
              label="Data geração de selo"
              name="data_inicial_geracao"
              :form-erros="formErros"
              type="date"
              @blur="setValueInput" />
            <span class="pl-2 pr-2 pt-4">até</span>

            <CustomInput
              label=" "
              class="mt-2"
              name="data_final_geracao"
              :form-erros="formErros"
              type="date"
              @blur="setValueInput" />
            <CustomSelect :options="optionsStatusSelo"
                          class="col-4"
                          label="Status selo"  
                          :max-height-display="400"
                          :selected="form.status_selo"  
                          @setSelectValue="(ev) => handlerStatusSelo(ev)" />
          </div>
        </div>

        <div class="d-flex align-items-center mt-3">
          <CustomInput
            label="Data de envio TJSP"
            name="data_inicial_envio_tj"
            type="date"
            @blur="setValueInput" />
          <span class="pl-2 pr-2 pt-4">até</span>
          <CustomInput
            label=" "
            class="mt-2"
            name="data_final_envio_tj"
            type="date"
            @blur="setValueInput" />

          <CustomSelect :options="optionsEnvioSelo"
                        class="col-3"
                        label="Status de envio do selo"  
                        :max-height-display="400"
                        :selected="form.status_envio_selo"  
                        @setSelectValue="(ev) => handlerEnvioSelo(ev)" />
          <CustomButton text="Filtrar"
                        class="mt-4"
                        @click="searchOS" />
        </div>
      </form>
      <hr>
      <div class="">
        <div class="row">
          <div class="col-4">
            <CustomSelect :options="optionsVisualizar"      
                          label="Visualizar"  
                          :max-height-display="400"
                          :selected="form.vizualizar"  
                          @setSelectValue="(ev) => form.visualizar = ev.value" />
          </div>
          <div class="col-3">
            <CustomSelect :options="optionsMostrar"      
                          label="Mostrar"  
                          :max-height-display="400"
                          :selected="form.perPage"  
                          @setSelectValue="(ev) => handlerMostrar(ev)" />
          </div>
          <div class="col-5 d-flex justify-content-end align-content-center text-right">
            <div class="mt-5 mr-2">
              <button class="btn btn-sm btn-secondary"
                      type="submit"
                      :disabled="!podeEnviarSelos(lista)"
                      @click="enviarSeloManualmenteTJ()">
                Enviar todos os selos
              </button>
            </div>
            <div class="mt-5">
              <button class="btn btn-sm btn-secondary"
                      type="submit"
                      @click="getRelatorio">
                <icon-svg icon="print"
                          class="icon--xs icons--white" />
                Imprimir
              </button>
            </div>
          </div>
        </div>
        
        <div v-if="lista.length" 
             class="ListaRelatorioSelos mt-3">
          <ListaRelatorioSelos :prop-lista-selos="lista"
                               :pode-enviar-selos="podeEnviarSelos"
                               @enviar-selo="enviarSeloManualmenteTJ" />
          <hr>
        </div>

        <div v-if="lista.length"
             class="Selos_footer col-12 justify-content-center align-items-center p-0 m-0 mt-2">
          <Pagination
            :per-page="form.perPage"
            :page="form.page"
            :last-page="form.lastPage"
            @onPreviousPage="() => form.page = form.page - 1"
            @onNextPage="() => form.page = form.page + 1" />
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"
  import CartorioService from "@/services/CartorioService"
  import RelatorioSeloService from "@/services/Relatorios/RelatorioSelosService"
  import SelosService from '@/services/Registros/SelosService'

  // Components
  import CustomInput from '@/components/CustomInputs/CustomInput.vue'
  import CustomSelect from '@/components/CustomInputs/CustomSelect.vue'
  import CustomButton from '@/components/CustomButton/CustomButton.vue'
  import Pagination from "@/components/SofiaRei/Pagination"

  /* others */
  import moment from "moment"
  import HeaderBlue from '../../../components/SofiaRei/Headers/HeaderBlue.vue'





  import ListaRelatorioSelos from '../../../components/RelatorioSelos/ListaRelatorioSelos.vue'

  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'

  export default {
    name: "Selos",
    components: {
      HeaderBlue,
      ListaRelatorioSelos,
      CustomInput,
      CustomSelect,
      CustomButton,
      Pagination
    },
    data () {
      return {
        busca: {
          filtro: 'diario',
          tipo: 'detalhado',
          cartorio_id: this.$store.state.auth.cartorio_id,
          data_inicial: null,
          data_final: null
        },
        lista: [],
        form: {
          numero: null,
          numero_do_selo: null,
          data_inicial_geracao: null,
          data_final_geracao: null,
          status_selo: 'todos',
          status_envio_selo: 'todos',
          data_inicial_envio_tj: null,
          data_final_envio_tj: null,
          visualizar: null,
          page: 1,
          perPage: 20,
          lastPage: null
        },
        formErros: [],
        optionsStatusSelo: [
          {
            text: 'Todos',
            value: 'todos'
          }, 
          {
            text: 'Ativo',
            value: 'ativo'
          }, 
          {
            text: 'Cancelado', 
            value: 'cancelado'
          }, 
          {
            text: 'Excluido', 
            value: 'excluido'
          },
        ],
        optionsEnvioSelo: [
          {
            text: 'Todos',
            value: 'todos'
          }, 
          {
            text: 'SUCESSO',
            value: 'SUCESSO'
          }, 
          {
            text: 'PENDENTE', 
            value: 'PENDENTE',
          }, 
          {
            text: 'ERRO', 
            value: 'ERRO'
          }
        ],
        optionsVisualizar: [
          {
            text: 'Selos gerados recentes',
            value: 'selos_recentes'
          },
          {
            text: 'Selos gerados antigos',
            value: 'selos_antigos'
          },
          {
            text: 'Envio TJ recentes',
            value: 'enviotj_recentes'
          },   
          {
            text: 'Envio TJ antigos',
            value: 'enviotj_antigos'
          },

          {
            text: 'Número OS crescente',
            value: 'os_recentes'
          },          {
            text: 'Número OS decrescente',
            value: 'os_antigas'
          },

        ],
        optionsMostrar: [
          {
            text: 1,
            value: 1
          },
          {
            text: 10,
            value: 10
          }, 
          {
            text: 20,
            value: 20
          }, 
          {
            text: 50,
            value: 50
          }, 
        ],
        page: 1,
        perPage: 20,
        lastPage: 1,
        search: {},
        showErrorDataFinal: false,
        showErrorDataInicial: false,
        cartorio: {},
        urlPdf: null,
      }
    },
    watch: {
      'form.page' () {
        this.searchOS()
      }
    },
    async created () {
      const { data } = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
      this.cartorio = data
    },
    methods: {
      setValueInput (nome, value) {

        this.form[nome] = value
      },
      setError (newArray) {
        console.log('error', newArray)
        this.formErros = newArray
      },
      handlerStatusSelo (status) {
        if (!status) {
          this.form.status_selo = 'todos'
          return
        }       
        this.form.status_selo = status.value
      },
      handlerEnvioSelo (ev) {
        if (!ev) {
          this.form.status_envio_selo = 'todos'
          return
        }       
        this.form.status_envio_selo = ev.value
      },
      handlerMostrar (ev) {
        if (!ev) {
          this.form.perPage = 20
          return
        }       
        this.form.perPage = ev.value
      },
      handlerVisualizar (ev) {
        if (!ev) {
          this.form.vizualizar = 'recentes'
          return
        }       
        this.form.vizualizar = ev.value
      },
      async searchOS () {
        try {
          loader({active: true})
          const res = await OrdensServicoService.getOsBySelo(this.form)

          if (res.data.data.length) {
            this.search = {...this.form}
            this.lista = res.data.data
            this.form.page = res.data.page
            this.form.lastPage = res.data.lastPage
            this.form.perPage = res.data.perPage

            if (this.form.visualizar === 'os_recentes') {
              this.lista.sort((a, b) => {
                // Acessando os números da ordem de serviço
                const numOrdemServicoA = a.seloItemOs.ordemServicoItem.ordemServico.numero
                const numOrdemServicoB = b.seloItemOs.ordemServicoItem.ordemServico.numero

                // Comparando de forma decrescente
                return numOrdemServicoA - numOrdemServicoB
              })
            }        
            if (this.form.visualizar === 'os_antigas') {
              this.lista.sort((a, b) => {
                // Acessando os números da ordem de serviço
                const numOrdemServicoA = a.seloItemOs.ordemServicoItem.ordemServico.numero
                const numOrdemServicoB = b.seloItemOs.ordemServicoItem.ordemServico.numero

                // Comparando de forma decrescente
                return numOrdemServicoB - numOrdemServicoA 
              })
            }

            
          } else {
            this.lista = []
            return displayMessage("error", null, "Nenhuma ordem de serviço encontrada!")
          }

        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false})
        }
      },
      async enviarSeloManualmenteTJ (selo) {
        try {
          const envioIndividual = !!selo
          const questionText = envioIndividual ? `Confirmar o envio manual do selo da OS ${selo.numeroOs}?` : 'Confirmar o envio manual de todos os selos?'
          const response = await displayQuestion(null, questionText, 'Sim', 'Não', null, '#074f7f', '#8b0000')

          if (!response) return

          const selos = envioIndividual ? [selo] : this.lista.filter(item => item.envio_tj === 0)

          let enviados = 0
          let falhas = 0
          const resultados = []

          for (let i = 0; i < selos.length; i++) {
            const seloAtual = selos[i]

            try {
              await SelosService.enviarNumeroSeloApi(seloAtual.num_selo)

              enviados++

              resultados.push({
                selo: seloAtual.num_selo,
                status: 'sucesso'
              })
            } catch (error) {
              falhas++

              let mensagemErro = 'Erro ao enviar selo'

              if (error && error.response && error.response.data && error.response.data.mensagem) {
                mensagemErro = error.response.data.mensagem
              } else if (error && error.response && error.response.data && error.response.data.error) {
                mensagemErro = error.response.data.error
              } else if (error && error.message) {
                mensagemErro = error.message
              }

              resultados.push({
                selo: seloAtual.num_selo,
                status: 'erro',
                erro: mensagemErro
              })
            }
          }

          // Todos já enviados
          if (enviados === 0 && falhas === 0) {
            displayMessage('success', null, 'Todos os selos já foram enviados ao TJ.', { confirmButtonText: 'Continuar' })

            this.searchOS()
            return
          }

          // Sucesso total
          if (falhas === 0) {
            displayMessage('success', null, envioIndividual ? 'Selo enviado com sucesso!' : 'Selos enviados com sucesso!', { confirmButtonText: 'Continuar' })

            this.searchOS()
            return
          }

          // Erro parcial
          const mensagens = resultados
            .filter(item => item.status === 'erro')
            .map(item => `• Selo ${item.selo}: ${item.erro}`)
            .join('<br>')

          displayMessage('success', null, mensagens, {useHtml: true, confirmButtonText: 'Continuar'})

          this.searchOS()

        } catch (error) {
          let mensagem = 'Ocorreu um erro ao enviar os selos para o TJ.'

          if (error && error.response && error.response.data && error.response.data.mensagem) {
            mensagem = error.response.data.mensagem
          } else if (error && error.response && error.response.data && error.response.data.message) {
            mensagem = error.response.data.message
          } else if (error && error.message) {
            mensagem = error.message
          }

          displayMessage('error', null, mensagem)
        }
      },
      podeEnviarSelos (selos) {
        if (!selos || selos.length === 0) {
          return false
        }

        return selos.some(selo => selo.envio_tj === 0)
      },
      async getRelatorio () {
        if (!this.form.data_inicial_geracao || !this.form.data_final_geracao) {
          return displayMessage('error', 'Error', 'Defina um intervalor de tempo da geração do selo para gerar o relatório!')
        }
   
        try {
          loader({ text: 'Gerando Relatório...', active: true })
          if (this.form)
            this.urlPdf = await RelatorioSeloService.getPdfRelatorio({ ...this.form, cartorio: this.cartorio })
          window.open(this.urlPdf)
        } catch (e) {
          displayMessage('error', 'Erro', 'Não há informações para gerar o relatŕoio que corresponda aos filtros!')
        } finally {
          loader({ active: false })
        }
      
       
      }
    }
  }
</script>

<style scoped
        lang="scss">
  .document-preview {
    height: 500px !important;
  }
  .Selos {
  &_header {
    font-family: Roboto;
    font-size: 1.25rem;
    font-weight: 500;
    font-style: normal;
    line-height: 1.33;
    color: #ffffff;
    background: #074f7f;
  }

  &_body {

  }

  &_label {
    color: #373a3c;
    font-weight: normal;
  }
}

</style>
